"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeType = void 0;
var RangeType;
(function (RangeType) {
    RangeType["WORK_DAY"] = "WORK_DAY";
    RangeType["FULL_DAY"] = "FULL_DAY";
    RangeType["WEEK"] = "WEEK";
    RangeType["MONTH"] = "MONTH";
    RangeType["YEAR"] = "YEAR";
    RangeType["SELECTED_RANGE"] = "SELECTED_RANGE";
    RangeType["RECORDER_MODE"] = "RECORDER_MODE";
})(RangeType || (exports.RangeType = RangeType = {}));
//# sourceMappingURL=time.js.map